import { formatMonthRangeLabel } from "@/ds";
import type { MonthRangeValue } from "@/ds";
import { formatUserPhone } from "@/modules/users";
import type { Profissional } from "@/modules/recursos";

import type { ProfissionalLinha } from "./types-profissionais";

const MONTH_NAMES = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

/** "Agosto/2026" para um mês só (Figma 5212:130632); o intervalo segue o rótulo do DS, que o Figma não desenha. */
export function formatPeriodoLabel(periodo: MonthRangeValue): string {
  const { from, to } = periodo;
  if (from.year !== to.year || from.month !== to.month) return formatMonthRangeLabel(periodo);

  return `${MONTH_NAMES[from.month - 1]}/${from.year}`;
}

/** `YYYY-MM-DD...`; o recorte evita qualquer deslocamento de fuso horário ao formatar. */
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

/** "30/08/2026", a partir da data ISO do contrato; sem ocorrência reconhecida, mostra como veio. */
export function formatDateBr(value: string): string {
  const match = ISO_DATE_PATTERN.exec(value);
  if (!match) return value;

  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}

/** Linha pronta para a tabela: telefone formatado e os períodos início → fim, sem o motivo (RN05/RN06). */
export function toProfissionalLinha(profissional: Profissional): ProfissionalLinha {
  return {
    id: profissional.id,
    cartao: {
      detalhe: [profissional.cargo, profissional.time].filter(Boolean).join(" · "),
      fotoUrl: profissional.fotoUrl,
      fotoPath: `/api/recursos/profissionais/${encodeURIComponent(profissional.id)}/foto`,
      testIds: {
        trigger: `profissionais-hover-${profissional.id}`,
        card: `profissionais-hover-card-${profissional.id}`,
        copy: `profissionais-copy-email-${profissional.id}`,
      },
    },
    nome: profissional.nome,
    email: profissional.email,
    telefone: formatUserPhone(profissional.telefone ?? ""),
    cargo: profissional.cargo,
    time: profissional.time,
    indisponivel: profissional.indisponibilidade.indisponivel,
    periodos: profissional.indisponibilidade.periodos.map((periodo, index) => ({
      key: `${periodo.inicio}-${periodo.fim}-${index}`,
      texto: `${formatDateBr(periodo.inicio)} → ${formatDateBr(periodo.fim)}`,
    })),
    rowTestId: `profissionais-row-${profissional.id}`,
    unavailableTestId: `profissionais-unavailable-${profissional.id}`,
  };
}
